import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const FaceYogaExperts = lazyWithPreload(
  () => import('./FaceYogaExperts'),
)
export const FaceYogaExpertsVariant2 = lazyWithPreload(
  () => import('./FaceYogaExpertsVariant2'),
)
